// Address
export const FETCH_ADDRESSES = 'FETCH_ADDRESSES'
export const FETCH_ADDRESSES_SUCCESS = 'FETCH_ADDRESSES_SUCCESS'
export const FETCH_ADDRESSES_FAILURE = 'FETCH_ADDRESSES_FAILURE'

// Card
export const FETCH_CARDS = 'FETCH_CARDS'
export const FETCH_CARDS_SUCCESS = 'FETCH_CARDS_SUCCESS'
export const FETCH_CARDS_FAILURE = 'FETCH_CARDS_FAILURE'

export const FETCH_CARD = 'FETCH_CARD'
export const FETCH_CARD_SUCCESS = 'FETCH_CARD_SUCCESS'
export const FETCH_CARD_FAILURE = 'FETCH_CARD_FAILURE'

export const RESOLVE_CONTINGENCY_FAILURE = 'RESOLVE_CONTINGENCY_FAILURE'

export const SHOW_CLASSIFIED_CARD_DATA = 'SHOW_CLASSIFIED_CARD_DATA'
export const SHOW_CLASSIFIED_CARD_DATA_SUCCESS = 'SHOW_CLASSIFIED_CARD_DATA_SUCCESS'
export const SHOW_CLASSIFIED_CARD_DATA_FAILURE = 'SHOW_CLASSIFIED_CARD_DATA_FAILURE'
export const CLASSIFIED_CARD_DATA_ERASE = 'CLASSIFIED_CARD_DATA_ERASE'

export const CANCEL_CARD = 'CANCEL_CARD'
export const CANCEL_CARD_SUCCESS = 'CANCEL_CARD_SUCCESS'
export const CANCEL_CARD_FAILURE = 'CANCEL_CARD_FAILURE'

export const CHANGE_PIN = 'CHANGE_PIN'
export const CHANGE_PIN_SUCCESS = 'CHANGE_PIN_SUCCESS'
export const CHANGE_PIN_FAILURE = 'CHANGE_PIN_FAILURE'

export const CHANGE_CVV = 'CHANGE_CVV'
export const CHANGE_CVV_SUCCESS = 'CHANGE_CVV_SUCCESS'
export const CHANGE_CVV_FAILURE = 'CHANGE_CVV_FAILURE'

export const VIEW_PIN = 'VIEW_PIN'
export const VIEW_PIN_SUCCESS = 'VIEW_PIN_SUCCESS'
export const VIEW_PIN_FAILURE = 'VIEW_PIN_FAILURE'
export const VIEW_PIN_ERASE = 'VIEW_PIN_ERASE'

export const FETCH_FUNDING_SUMMARY = 'FETCH_FUNDING_SUMMARY'
export const FETCH_FUNDING_SUMMARY_SUCCESS = 'FETCH_FUNDING_SUMMARY_SUCCESS'
export const FETCH_FUNDING_SUMMARY_FAILURE = 'FETCH_FUNDING_SUMMARY_FAILURE'

export const FETCH_FUNDING_DETAILS = 'FETCH_FUNDING_DETAILS'
export const FETCH_FUNDING_DETAILS_SUCCESS = 'FETCH_FUNDING_DETAILS_SUCCESS'
export const FETCH_FUNDING_DETAILS_FAILURE = 'FETCH_FUNDING_DETAILS_FAILURE'

export const SET_FUNDING = 'SET_FUNDING'
export const SET_FUNDING_SUCCESS = 'SET_FUNDING_SUCCESS'
export const SET_FUNDING_FAILURE = 'SET_FUNDING_FAILURE'

export const REMOVE_FUNDING = 'REMOVE_FUNDING'
export const REMOVE_FUNDING_SUCCESS = 'REMOVE_FUNDING_SUCCESS'
export const REMOVE_FUNDING_FAILURE = 'REMOVE_FUNDING_FAILURE'

export const APPLY_CARD = 'APPLY_CARD'
export const APPLY_CARD_SUCCESS = 'APPLY_CARD_SUCCESS'
export const APPLY_CARD_FAILURE = 'APPLY_CARD_FAILURE'

export const CREATE_CARD = 'CREATE_CARD'
export const CREATE_CARD_SUCCESS = 'CREATE_CARD_SUCCESS'
export const CREATE_CARD_FAILURE = 'CREATE_CARD_FAILURE'

export const RESET_CARD_REQUEST = 'RESET_CARD_REQUEST'
export const RESET_FUNDING_REQUEST = 'RESET_FUNDING_REQUEST'

// Card Lock
export const DEACTIVATE_CARD = 'DEACTIVATE_CARD'
export const DEACTIVATE_CARD_SUCCESS = 'DEACTIVATE_CARD_SUCCESS'
export const DEACTIVATE_CARD_FAILURE = 'DEACTIVATE_CARD_FAILURE'

// Card Unlock
export const REACTIVATE_CARD = 'REACTIVATE_CARD'
export const REACTIVATE_CARD_SUCCESS = 'REACTIVATE_CARD_SUCCESS'
export const REACTIVATE_CARD_FAILURE = 'REACTIVATE_CARD_FAILURE'

// Common
export const CHECK_SESSION = 'CHECK_SESSION'
export const SESSION_EXPIRED = 'SESSION_EXPIRED'
export const REQUEST_BLOCKED = 'REQUEST_BLOCKED'
export const NOT_FOUND = 'NOT_FOUND'
export const RESET_NOT_FOUND = 'RESET_NOT_FOUND'
export const SHOW_LOADING_SPINNER = 'SHOW_LOADING_SPINNER'
